import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const STATIC_PAGE_HEADER_FONT_SIZE = "22px";
export const STATIC_PAGE_DESCRIPTION_FONT_SIZE = "14px";
export const STATIC_PAGE_CARD_FONT_SIZE = "13.5px";

export const useStaticPageStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
    fontFamily: projectIqTokens.fontFamily,
    padding: "16px 32px",
  },
  content: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
  },
  heading: {
    fontSize: STATIC_PAGE_HEADER_FONT_SIZE,
    fontWeight: 800,
    color: projectIqTokens.ink,
    letterSpacing: "-0.02em",
    margin: "0",
  },
  description: {
    fontSize: STATIC_PAGE_DESCRIPTION_FONT_SIZE,
    color: projectIqTokens.muted,
    lineHeight: String(designTokens.lineHeight.normal),
    margin: "0",
  },
  card: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    padding: `${designTokens.spacing[6]} ${designTokens.spacing[6]}`,
    fontSize: STATIC_PAGE_CARD_FONT_SIZE,
    color: projectIqTokens.muted,
    lineHeight: String(designTokens.lineHeight.normal),
  },
});
